export const theme = {
  colors: {
    primary: '#2fc9cb',
    darkGreen: '#00a8a8',
    red: '#f05a5b',
    white: '#fff',
    grey: '#bbb',
    lightGrey: '#efefef',
    darkGrey: '#373737',
  },
};
